import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { LazyLoadComponent } from '@src/components/LazyLoadComponent/LazyLoadComponent';

const B2CDiscountCodeList = lazy(() =>
    import('../../pages/B2CManagement/DiscountCode').then((module) => ({
        default: module.DiscountCodeList,
    }))
);

const DiscountCodeForm = lazy(() =>
    import(
        '../../pages/B2CManagement/DiscountCode/DiscountCodeForm/DiscountCode.Form'
    ).then((module) => ({
        default: module.DiscountCodeForm,
    }))
);

const DiscountCodeDetails = lazy(() =>
    import('../../pages/B2CManagement/DiscountCode/DiscountCode.Details').then(
        (module) => ({
            default: module.DiscountCodeDetails,
        })
    )
);
export function B2CDiscountCodeContainer() {
    return (
        <Routes>
            <Route path="new" element={<DiscountCodeForm />} />
            <Route path="edit/:codeId" element={<DiscountCodeForm />} />
            <Route path=":codeId/details" element={<DiscountCodeDetails />} />
            <Route
                path={'*'}
                element={
                    <LazyLoadComponent
                        type="LIST"
                        Component={<B2CDiscountCodeList />}
                    />
                }
            />
        </Routes>
    );
}
